import { useState } from "react";
import "./Emailsms.css";

export default function EmailSmsSettings() {
    const [userType, setUserType] = useState(""); // "all" or "specific"
    const [selectedUser, setSelectedUser] = useState(""); // Specific user ID
    const [notificationType, setNotificationType] = useState(""); // email, sms, or both
    const [email, setEmail] = useState(""); // Email input
    const [phone, setPhone] = useState(""); // Phone input
    const [subject, setSubject] = useState(""); // Subject input
    const [message, setMessage] = useState(""); // Message input


    // Handle Send Button Click
    const handleSend = () => {
        if (!userType) {
            alert("Please select whether to send to all users or a specific user.");
            return;
        }
        if (userType === "specific" && !selectedUser) {
            alert("Please select a user.");
            return;
        }
        if (notificationType === "email" && !email) {
            alert("Please enter an email address.");
            return;
        }
        if (notificationType === "sms" && !phone) {
            alert("Please enter a phone number.");
            return;
        }
        if (notificationType === "both" && (!email || !phone)) {
            alert("Please enter both email and phone number.");
            return;
        }

        alert(`Sending ${notificationType} to ${userType === "all" ? "All Users" : (notificationType === "email" ? email : phone)} with subject: ${subject} and message: ${message}`);
    };

    return (
        <div className="settings-container">
            <h2 className="settings-title">Email & SMS Settings</h2>

          
            {/* Select User Type */}
            <label className="settings-label">Send To</label>
            <select
                className="settings-select"
                value={userType}
                onChange={(e) => {
                    setUserType(e.target.value);
                    setSelectedUser("");
                    setEmail("");
                    setPhone("");
                }}
            >
                <option value="">-- Select --</option>
                <option value="all">All Users</option>
                <option value="specific">Specific User</option>
            </select>


            {/* Select Notification Type */}
            <label className="settings-label">Notification Type</label>
            <div className="settings-radio-group">
                <input
                    type="radio"
                    id="email"
                    name="notificationType"
                    value="email"
                    onChange={(e) => { setNotificationType(e.target.value); }}
                />
                <label htmlFor="email">Email</label>

                <input
                    type="radio"
                    id="sms"
                    name="notificationType"
                    value="sms"
                    onChange={(e) => { setNotificationType(e.target.value); }}
                />
                <label htmlFor="sms">SMS</label>

                <input
                    type="radio"
                    id="both"
                    name="notificationType"
                    value="both"
                    onChange={(e) => { setNotificationType(e.target.value); }}
                />
                <label htmlFor="both">Email & SMS</label>
            </div>

            {/* Recipient Fields */}
            {userType === "specific" && notificationType === "email" && (
                <>
                    <label className="settings-label">Recipient Email</label>
                    <input
                        type="email"
                        className="settings-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </>
            )}

            {userType === "specific" && notificationType === "sms" && (
                <>
                    <label className="settings-label">Recipient Phone</label>
                    <input
                        type="tel"
                        className="settings-input"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    />
                </>
            )}

            {userType === "specific" && notificationType === "both" && (
                <>
                    <label className="settings-label">Recipient Email</label>
                    <input
                        type="email"
                        className="settings-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />

                    <label className="settings-label">Recipient Phone</label>
                    <input
                        type="tel"
                        className="settings-input"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    />
                </>
            )}

            {/* Subject (Disabled for SMS) */}
            {notificationType !== "sms" && (
                <>
                    <label className="settings-label">Subject</label>
                    <input
                        type="text"
                        className="settings-input"
                        placeholder="Enter subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                    />
                </>
            )}

            {/* Message */}
            <label className="settings-label">Message</label>
            <textarea
                className="settings-textarea"
                placeholder="Enter your message"
                rows="4"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
            ></textarea>

            {/* Send Button */}
            <button
                className="settings-button"
                onClick={handleSend}
                disabled={!userType || (userType === "specific" && !selectedUser) || (!email && !phone)}
            >
                Send Notification
            </button>
        </div>
    );
}
